import { DELETE_ISSUE } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_ISSUE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ISSUE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_ISSUE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
